import * as z from 'zod';
import { getRouteApi } from '@tanstack/react-router';

import { homeDialogSchema } from '@shared/lib/home-drawer-route';

import { ModeType, modeTypeSchema } from './home.context';

const routeApi = getRouteApi('/');

export type Sections = z.infer<typeof modeTypeSchema>;

export const sectionSchema = modeTypeSchema.optional();

export type SectionSchema = z.infer<typeof sectionSchema>;

export const homeSearchSchema = z.object({
	section: sectionSchema,
	// Token auth's credential -- read by `app.router.tsx`'s `beforeLoad`
	// (`token-auth-guard.ts`'s `tokenAuthGuard`) on both this route and the
	// `issues` route, so it's declared in each route's own schema rather
	// than owned by one.
	token: z.string().optional(),
	// The selected-issue id `magazines.hooks.ts`'s `useSelectIssue` reads
	// and writes back via `navigate({ search: ... } )`.
	id: z.string().optional(),
	// Which home drawer is open -- see `@shared/lib/home-drawer-route`.
	dialog: homeDialogSchema,
});

export type HomeSearch = z.infer<typeof homeSearchSchema>;

/**
 * Derived during render, not set from an effect: the reader's Back
 * (`widgets/issue-reader`'s `useReaderGoBack`) takes its view-transition
 * "after" snapshot as soon as this route resolves, and an effect-set mode
 * left that first render empty (`HomeView` returns `null` without one) --
 * so there was no cover for the morph to land on.
 */
export function useMode(): ModeType {
	const { section }: HomeSearch = routeApi.useSearch();
	// `library` is no longer a section of its own -- favorites open in
	// `FavoritesDrawer` instead -- so an old `?section=library` link lands on
	// magazines like any other unknown section.
	if (section === 'daily-news' || section === 'top-stories') {
		return section;
	}
	return 'magazines';
}
